import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Common.css";
import badmintonBg from "../assets/practice.png";
import { api, API_ROOT_URL, changePassword, uploadPlayerPhoto } from "../API/Api.js";

/* ── Custom SVGs for Dashboard UI ── */
const DownloadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>
);
const HomeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>
);
const EditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
);
const ShuttleBadgeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 26 26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="13" cy="13" r="11" />
    <circle cx="13" cy="13" r="5" />
    <line x1="13" y1="2" x2="13" y2="24" />
    <line x1="2" y1="13" x2="24" y2="13" />
  </svg>
);

const DIST_T = [
  {
    no: 1,
    date: "18–21 June, 2026",
    cat: "U11, U13, U15, U17, U19, OPEN, MASTERS 35+, MASTERS 45+",
    venue: "TO BE DECLARED SOON",
    dist: "Anand",
    badge: "cb-ranking",
    hl: true
  }, {
    no: 2,
    date: "18–21 June, 2026",
    cat: "U11, U13, U15, U17, U19, OPEN, MASTERS 35+, MASTERS 45+",
    venue: "TO BE DECLARED SOON",
    dist: "Anand",
    badge: "cb-ranking",
    hl: true
  }, {
    no: 3,
    date: "18–21 June, 2026",
    cat: "U11, U13, U15, U17, U19, OPEN, MASTERS 35+, MASTERS 45+",
    venue: "TO BE DECLARED SOON",
    dist: "Anand",
    badge: "cb-ranking",
    hl: true
  }, {
    no: 4,
    date: "18–21 June, 2026",
    cat: "U11, U13, U15, U17, U19, OPEN, MASTERS 35+, MASTERS 45+",
    venue: "TO BE DECLARED SOON",
    dist: "Anand",
    badge: "cb-ranking",
    hl: true
  }, {
    no: 5,
    date: "18–21 June, 2026",
    cat: "U11, U13, U15, U17, U19, OPEN, MASTERS 35+, MASTERS 45+",
    venue: "TO BE DECLARED SOON",
    dist: "Anand",
    badge: "cb-ranking",
    hl: true
  },

];

const UserDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // States for tournament registrations checking
  const [registrationStatuses, setRegistrationStatuses] = useState({});
  const [loadingRegistrations, setLoadingRegistrations] = useState(false);


  // State for registered players under user
  const [players, setPlayers] = useState([]);
  const [selectedPlayerId, setSelectedPlayerId] = useState("");
  const [playerDetails, setPlayerDetails] = useState(null);
  const [loadingPlayers, setLoadingPlayers] = useState(true);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [apiError, setApiError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [membershipStatus, setMembershipStatus] = useState({ isLoading: false, isActive: null, error: null });

  // States for Edit Profile modal
  const [isEditProfileOpen, setIsEditProfileOpen] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [selectedPhotoFile, setSelectedPhotoFile] = useState(null);
  const [photoPreviewUrl, setPhotoPreviewUrl] = useState("");
  const [isSubmittingProfile, setIsSubmittingProfile] = useState(false);
  const [editProfileError, setEditProfileError] = useState("");
  const [editProfileSuccess, setEditProfileSuccess] = useState("");

  // States for Tournaments & Calendar
  const [tournaments, setTournaments] = useState([]);
  const [masterCategories, setMasterCategories] = useState([]);
  const [loadingTournaments, setLoadingTournaments] = useState(true);
  const [registrationModalTournament, setRegistrationModalTournament] = useState(null);
  const [registeringStatus, setRegisteringStatus] = useState({ loading: false, success: null, error: null, categoryId: null });
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);

  const [razorpayScriptLoaded, setRazorpayScriptLoaded] = useState(false);

  // Reset registeringStatus when modal opens or closes
  useEffect(() => {
    setRegisteringStatus({ loading: false, success: null, error: null, categoryId: null });
    setSelectedCategoryIds([]);
  }, [registrationModalTournament]);

  // Dynamically load Razorpay SDK on mount
  useEffect(() => {
    if (window.Razorpay) {
      setRazorpayScriptLoaded(true);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => setRazorpayScriptLoaded(true);
    script.onerror = () => {
      console.error("Failed to load Razorpay SDK in UserDashboard");
    };
    document.body.appendChild(script);
  }, []);

  const token = sessionStorage.getItem("token");

  // Verify login status and fetch my players list
  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }

    const fetchPlayers = async () => {
      try {
        setLoadingPlayers(true);
        setApiError("");
        const response = await api.get("/Player/my-players");
        const data = response.data;
        if (Array.isArray(data) && data.length > 0) {
          setPlayers(data);

          // Restore selected player ID from sessionStorage if valid
          const savedPlayerId = sessionStorage.getItem("selectedPlayerId");
          const playerExists = data.some(p => (p.playerId || p.PlayerId) === savedPlayerId);

          if (savedPlayerId && playerExists) {
            setSelectedPlayerId(savedPlayerId);
          } else {
            const firstPlayerId = data[0].playerId || data[0].PlayerId;
            setSelectedPlayerId(firstPlayerId);
            sessionStorage.setItem("selectedPlayerId", firstPlayerId);
          }
        } else {
          setPlayers([]);
        }
      } catch (err) {
        console.error("Error fetching my-players:", err);
        setApiError("Failed to fetch players list.");
      } finally {
        setLoadingPlayers(false);
      }
    };

    fetchPlayers();
  }, [token, navigate]);

  // Save selected player ID to sessionStorage when it changes
  useEffect(() => {
    if (selectedPlayerId) {
      sessionStorage.setItem("selectedPlayerId", selectedPlayerId);
    }
  }, [selectedPlayerId]);

  // Fetch details for selected player
  useEffect(() => {
    if (!selectedPlayerId) {
      setPlayerDetails(null);
      return;
    }

    const fetchPlayerDetails = async () => {
      try {
        setLoadingDetails(true);
        const response = await api.get(`/Player/${selectedPlayerId}`);
        setPlayerDetails(response.data);
      } catch (err) {
        console.error(`Error fetching player details for ${selectedPlayerId}:`, err);
        // Try parsing fallback from mock/registered players list
        const basicInfo = players.find(p => (p.playerId || p.PlayerId) === selectedPlayerId);
        if (basicInfo) {
          setPlayerDetails({
            FirstName: basicInfo.firstName || basicInfo.FirstName,
            LastName: basicInfo.lastName || basicInfo.LastName,
            Dob: basicInfo.dob || basicInfo.Dob,
            Gender: basicInfo.gender || basicInfo.Gender,
            PlayerCode: basicInfo.playerCode || basicInfo.PlayerCode || "ADBA-PL-PENDING",
            District: "Anand",
            SubDistrict: "N/A"
          });
        }
      } finally {
        setLoadingDetails(false);
      }
    };

    fetchPlayerDetails();
  }, [selectedPlayerId, players]);


  // useEffect(() => {
  //   if (!selectedPlayerId) {
  //     setMembershipStatus({ isLoading: false, isActive: null, error: null });
  //     return;
  //   }

  //   const checkMembership = async () => {
  //     setMembershipStatus(prev => ({ ...prev, isLoading: true, error: null }));
  //     try {
  //       const response = await api.get(`/Player/membership-status/${selectedPlayerId}`);
  //       const data = response.data;
  //       // data is expected to be an array of registrations
  //       if (Array.isArray(data) && data.length > 0) {
  //         const now = new Date();
  //         const hasActive = data.some(reg => {
  //           const expiry = new Date(reg.expiryDate);
  //           return reg.paymentStatus === "Paid" && expiry >= now;
  //         });
  //         setMembershipStatus({ isLoading: false, isActive: hasActive, error: null });
  //       } else {
  //         setMembershipStatus({ isLoading: false, isActive: false, error: null });
  //       }
  //     } catch (err) {
  //       console.error("Membership status check failed:", err);
  //       setMembershipStatus({ isLoading: false, isActive: false, error: "Failed to verify membership" });
  //     }
  //   };

  //   checkMembership();
  // }, [selectedPlayerId]);


  useEffect(() => {
    if (!selectedPlayerId) {
      setMembershipStatus({ isLoading: false, hasRecord: false, isActive: false, error: null });
      return;
    }

    const checkMembership = async () => {
      setMembershipStatus(prev => ({ ...prev, isLoading: true, error: null }));
      try {
        const response = await api.get(`/Player/membership-status/${selectedPlayerId}`);
        const data = response.data;

        if (Array.isArray(data) && data.length > 0) {
          // At least one membership record exists
          const now = new Date();
          const hasActive = data.some(reg => {
            const expiry = new Date(reg.expiryDate);
            return reg.paymentStatus === "Paid" && expiry >= now;
          });
          setMembershipStatus({
            isLoading: false,
            hasRecord: true,
            isActive: hasActive,
            error: null
          });
        } else {
          // No membership record found
          setMembershipStatus({
            isLoading: false,
            hasRecord: false,
            isActive: false,
            error: null
          });
        }
      } catch (err) {
        console.error("Membership status check failed:", err);
        setMembershipStatus({
          isLoading: false,
          hasRecord: false,
          isActive: false,
          error: "Failed to verify membership"
        });
      }
    };

    checkMembership();
  }, [selectedPlayerId]);


  // Fetch Tournaments and Master Event Categories
  useEffect(() => {
    const fetchTournamentsAndCategories = async () => {
      try {
        setLoadingTournaments(true);
        const [tournamentsRes, categoriesRes] = await Promise.all([
          api.get("/Tournament/list"),
          api.get("/Master/event-categories")
        ]);

        if (Array.isArray(tournamentsRes.data)) {
          setTournaments(tournamentsRes.data);
        }
        if (Array.isArray(categoriesRes.data)) {
          setMasterCategories(categoriesRes.data);
        }
      } catch (err) {
        console.error("Error fetching tournaments/categories:", err);
      } finally {
        setLoadingTournaments(false);
      }
    };

    fetchTournamentsAndCategories();
  }, []);

  // Check registration status for all categories of all tournaments when player or tournaments change
  useEffect(() => {
    if (!selectedPlayerId || tournaments.length === 0) {
      setRegistrationStatuses({});
      return;
    }

    const checkAllRegistrations = async () => {
      setLoadingRegistrations(true);
      const statuses = {};
      const allCategories = tournaments.flatMap(t => t.categories || []);

      try {
        await Promise.all(
          allCategories.map(async (cat) => {
            const catId = cat.tournamentCategoryId;
            try {
              const response = await api.get(
                `/Tournament/check-registration?playerId=${selectedPlayerId}&tournamentCategoryId=${catId}`
              );
              statuses[catId] = response.data.isRegistered;
            } catch (err) {
              console.error(`Error checking registration for category ${catId}:`, err);
              statuses[catId] = false;
            }
          })
        );
        setRegistrationStatuses(statuses);
      } catch (err) {
        console.error("Error in batch check-registration:", err);
      } finally {
        setLoadingRegistrations(false);
      }
    };

    checkAllRegistrations();
  }, [selectedPlayerId, tournaments]);

  // Helper to map categoryId to category name
  const getTournamentCategoryNames = (tournamentCats) => {
    if (!Array.isArray(tournamentCats)) return [];
    return tournamentCats.map(tc => {
      const match = masterCategories.find(mc => mc.categoryId === tc.categoryId);
      return {
        tournamentCategoryId: tc.tournamentCategoryId,
        name: match ? match.name || `${match.ageGroup} - ${match.eventType}` : `Category ${tc.categoryId}`
      };
    });
  };

  // Helper to format Date Range nicely
  const formatDateRange = (start, end) => {
    if (!start) return "";
    const sDate = new Date(start);
    const eDate = end ? new Date(end) : null;
    const options = { day: 'numeric', month: 'short' };

    if (eDate && sDate.getFullYear() === eDate.getFullYear() && sDate.getMonth() === eDate.getMonth()) {
      return `${sDate.getDate()}–${eDate.getDate()} ${sDate.toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}`;
    }

    const sStr = sDate.toLocaleDateString('en-US', options);
    const eStr = eDate ? eDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' }) : "";
    return eDate ? `${sStr} – ${eStr}` : sStr;
  };

  // Helper to determine tournament status
  const getTournamentStatus = (startDateStr, endDateStr) => {
    if (!startDateStr) return "Closed";
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const start = new Date(startDateStr);
    start.setHours(0, 0, 0, 0);

    const end = endDateStr ? new Date(endDateStr) : null;
    if (end) end.setHours(0, 0, 0, 0);

    if (start > today) {
      return "Upcoming";
    } else if (end && today > end) {
      return "Closed";
    } else {
      return "Ongoing";
    }
  };

  // Handle Tournament Player Registration API call for multiple selected categories with Razorpay Payment Integration
  const handleRegisterPlayerForSelectedCategories = async () => {
    if (!selectedPlayerId) {
      alert("Please select a player profile first.");
      return;
    }
    if (selectedCategoryIds.length === 0) {
      alert("Please select at least one category to register.");
      return;
    }
    if (!razorpayScriptLoaded && !window.Razorpay) {
      alert("Payment gateway is still loading. Please try again in a moment.");
      return;
    }

    setRegisteringStatus({ loading: true, success: "Verifying membership status...", error: null, categoryId: null });

    // Verify player is an active member before opening payment gateway
    try {
      const response = await api.get(`/Player/membership-status/${selectedPlayerId}`);
      const data = response.data;

      let hasActive = false;
      if (Array.isArray(data) && data.length > 0) {
        const now = new Date();
        hasActive = data.some(reg => {
          const expiry = new Date(reg.expiryDate);
          return reg.paymentStatus === "Paid" && expiry >= now;
        });
      }

      if (!hasActive) {
        setRegisteringStatus({
          loading: false,
          success: null,
          error: "Registration Denied: Player is not an active member for the current season. Please purchase or renew membership first.",
          categoryId: null
        });
        return;
      }
    } catch (err) {
      console.error("Failed to verify membership status before payment:", err);
      setRegisteringStatus({
        loading: false,
        success: null,
        error: "Failed to verify membership status. Please check your internet connection and try again.",
        categoryId: null
      });
      return;
    }

    // Membership verified! Proceed with Razorpay Payment Gateway
    setRegisteringStatus({ loading: true, success: "Connecting to secure payment gateway...", error: null, categoryId: null });

    const totalAmount = (registrationModalTournament.entryFee || 0) * selectedCategoryIds.length;

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID, // Loaded from environment or test fallback
      amount: totalAmount * 100, // Amount in paise
      currency: "INR",
      name: "Anand District Badminton Association",
      description: `Tournament Registration: ${registrationModalTournament.tournamentName}`,
      image: "/logo.png",
      handler: async function (response) {
        // Payment successful! Now write player registrations to the database
        await handleRegisterDatabaseAfterPayment(response.razorpay_payment_id);
      },
      prefill: {
        name: `${player.FirstName || ""} ${player.LastName || ""}`,
        email: `${(player.FirstName || "player").toLowerCase()}.${(player.LastName || "adba").toLowerCase()}@adba-player.in`,
        contact: sessionStorage.getItem("mobileNumber") || ""
      },
      notes: {
        purpose: "Tournament Registration Fee",
        playerId: selectedPlayerId,
        tournamentId: registrationModalTournament.tournamentId,
        categories: selectedCategoryIds.join(",")
      },
      theme: {
        color: "#CC0000"
      },
      modal: {
        ondismiss: function () {
          setRegisteringStatus({
            loading: false,
            success: null,
            error: "Payment cancelled by user. Registration aborted.",
            categoryId: null
          });
        }
      }
    };

    try {
      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", async function (response) {
        console.error("Payment Failed Details:", response.error);

        const failedPaymentId = response.error?.metadata?.payment_id;
        if (failedPaymentId) {
          try {
            const paymentPayload = {
              playerId: selectedPlayerId,
              amount: totalAmount,
              paymentType: "Tournament Registration",
              gateway: "Razorpay",
              transactionId: failedPaymentId,
              status: "Failed"
            };
            await api.post("/Payment/store", paymentPayload);
            console.log("Failed payment registered in DB:", failedPaymentId);
          } catch (dbErr) {
            console.error("Failed to store failed payment details in database:", dbErr);
          }
        }

        setRegisteringStatus({
          loading: false,
          success: null,
          error: `Payment failed: ${response.error?.description || "Unknown error"}. Reference ID: ${failedPaymentId || "N/A"}`,
          categoryId: null
        });
      });
      rzp.open();
    } catch (err) {
      console.error("Razorpay trigger error:", err);
      setRegisteringStatus({
        loading: false,
        success: null,
        error: "Failed to initialize payment gateway. Please try again.",
        categoryId: null
      });
    }
  };

  // Callback to register categories in the database after successful payment
  const handleRegisterDatabaseAfterPayment = async (razorpayPaymentId) => {
    setRegisteringStatus({ loading: true, success: "Payment verified! Saving registration details in database...", error: null, categoryId: null });

    const totalAmount = (registrationModalTournament.entryFee || 0) * selectedCategoryIds.length;
    let dbPaymentId = null;

    try {
      const paymentPayload = {
        playerId: selectedPlayerId,
        amount: totalAmount,
        paymentType: "Tournament Registration",
        gateway: "Razorpay",
        transactionId: razorpayPaymentId,
        status: "Paid"
      };
      const paymentResponse = await api.post("/Payment/store", paymentPayload);
      dbPaymentId = paymentResponse.data.paymentId || paymentResponse.data.PaymentId;
    } catch (err) {
      console.error("Failed to store payment details in database:", err);
      let errMsg = "Failed to save payment record.";
      if (err.response?.data) {
        if (typeof err.response.data === "string") {
          errMsg = err.response.data;
        } else if (err.response.data.message) {
          errMsg = err.response.data.message;
        } else if (err.response.data.error) {
          errMsg = err.response.data.error;
        }
      }
      setRegisteringStatus({
        loading: false,
        success: null,
        error: `Payment was successful, but database recording failed: ${errMsg}. Please contact support with Payment Ref: ${razorpayPaymentId}`,
        categoryId: null
      });
      return;
    }

    const succeededIds = [];
    let lastErrorMsg = "";

    for (const categoryId of selectedCategoryIds) {
      try {
        const payload = {
          playerId: selectedPlayerId,
          tournamentCategoryId: categoryId,
          paymentId: dbPaymentId // Save database payment GUID reference in registration record
        };
        await api.post("/Tournament/register-player", payload);
        succeededIds.push(categoryId);
      } catch (err) {
        console.error(`Failed to register category ${categoryId}:`, err);
        let errMsg = "Unknown error";
        if (err.response?.data) {
          if (typeof err.response.data === "string") {
            errMsg = err.response.data;
          } else if (err.response.data.message) {
            errMsg = err.response.data.message;
          } else if (err.response.data.error) {
            errMsg = err.response.data.error;
          }
        } else if (err.message) {
          errMsg = err.message;
        }
        lastErrorMsg = errMsg;
      }
    }

    if (succeededIds.length > 0) {
      const updatedStatuses = { ...registrationStatuses };
      succeededIds.forEach(id => {
        updatedStatuses[id] = true;
      });
      setRegistrationStatuses(updatedStatuses);
    }

    if (succeededIds.length === selectedCategoryIds.length) {
      // All succeeded
      const succeededNames = getTournamentCategoryNames(registrationModalTournament.categories)
        .filter(c => succeededIds.includes(c.tournamentCategoryId))
        .map(c => c.name)
        .join(", ");

      setRegisteringStatus({
        loading: false,
        success: `Successfully registered for: ${succeededNames}! (Payment Ref: ${razorpayPaymentId})`,
        error: null,
        categoryId: null
      });
      setSelectedCategoryIds([]);

      // Auto close the registration modal after 2.5 seconds
      setTimeout(() => {
        setRegistrationModalTournament(null);
        setRegisteringStatus({ loading: false, success: null, error: null, categoryId: null });
      }, 2500);
    } else if (succeededIds.length > 0) {
      // Partial success
      const succeededNames = getTournamentCategoryNames(registrationModalTournament.categories)
        .filter(c => succeededIds.includes(c.tournamentCategoryId))
        .map(c => c.name)
        .join(", ");

      setRegisteringStatus({
        loading: false,
        success: `Registered for: ${succeededNames}. (Payment Ref: ${razorpayPaymentId})`,
        error: `Failed for remaining categories: ${lastErrorMsg}`,
        categoryId: null
      });
      // Clear selected categories that succeeded
      setSelectedCategoryIds(prev => prev.filter(id => !succeededIds.includes(id)));
    } else {
      // All failed
      setRegisteringStatus({
        loading: false,
        success: null,
        error: `Payment was successful, but database registration failed: ${lastErrorMsg}. Please contact support with Payment Ref: ${razorpayPaymentId}`,
        categoryId: null
      });
    }
  };

  // Format output data mapping safely supporting camelCase or PascalCase API schemas
  const getPlayerDisplayData = () => {
    if (playerDetails) {
      return {
        PlayerId: playerDetails.playerId || playerDetails.PlayerId || "",
        PlayerCode: playerDetails.playerCode || playerDetails.PlayerCode || "Not Created player Code",
        FirstName: playerDetails.firstName || playerDetails.FirstName || "",
        LastName: playerDetails.lastName || playerDetails.LastName || "",
        Dob: playerDetails.dob || playerDetails.Dob || "",
        Gender: playerDetails.gender || playerDetails.Gender || "",
        District: playerDetails.district || playerDetails.District || "Anand",
        SubDistrict: playerDetails.subDistrict || playerDetails.SubDistrict || playerDetails.taluka || playerDetails.Taluka || "",
        InstitutionName: playerDetails.institutionName || playerDetails.InstitutionName || "N/A",
        Address: playerDetails.address || playerDetails.Address || "N/A",
        PaymentId: playerDetails.paymentId || playerDetails.PaymentId || "N/A",
        PhotoUrl: API_ROOT_URL + playerDetails.photoUrl || playerDetails.PhotoUrl || "",
        CreatedDate: playerDetails.createdDate || playerDetails.CreatedDate || new Date().toISOString()
      };
    }

    // Redirect state or local fallback
    if (location.state?.player) {
      return location.state.player;
    }
    const stored = sessionStorage.getItem("registered_player");
    if (stored) {
      try {
        return JSON.parse(stored);
      } catch (e) {
        console.error("Failed to parse stored player details", e);
      }
    }
    return {
      PlayerId: "e7f8a9a0-b1c2-d3e4-f5a6-7b8c9d0e1f2a",
      PlayerCode: "ADBA-PL-7708",
      FirstName: "GUEST",
      LastName: "Patel",
      Dob: "2005-08-14",
      Gender: "Male",
      District: "Anand",
      SubDistrict: "Umreth",
      InstitutionName: "ADBA Badminton Academy",
      Address: "12, Shrinagar Society, Near Town Hall, Anand - 388001",
      PaymentId: "pay_MOCK_SANDBOX_7708",
      CreatedDate: new Date().toISOString()
    };
  };

  const player = getPlayerDisplayData();

  const generatePDF = () => {
    const element = document.querySelector(".reg-id-card");
    if (!element) return;

    // Save current scroll position to restore later
    const currentScrollY = window.scrollY;

    // Temporarily scroll to top so canvas captures element without scroll offsets
    window.scrollTo(0, 0);

    // Force horizontal desktop styling temporarily for high-res print capturing
    element.classList.add("pdf-capture-active");

    const options = {
      margin: [10, 10, 10, 10],
      filename: `ADBA-Player-Card-${player.PlayerCode}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 3,
        useCORS: true,
        logging: false,
        scrollX: 0,
        scrollY: 0
      },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }
    };

    window.html2pdf()
      .from(element)
      .set(options)
      .save()
      .then(() => {
        element.classList.remove("pdf-capture-active");
        // Restore scroll position
        window.scrollTo(0, currentScrollY);
      })
      .catch((err) => {
        console.error("PDF generation failed:", err);
        element.classList.remove("pdf-capture-active");
        // Restore scroll position
        window.scrollTo(0, currentScrollY);
      });
  };

  const handleDownloadPDF = () => {
    if (window.html2pdf) {
      generatePDF();
    } else {
      const script = document.createElement("script");
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js";
      script.onload = () => {
        generatePDF();
      };
      document.body.appendChild(script);
    }
  };

  // Reset Edit Profile states when modal opens/closes
  useEffect(() => {
    if (isEditProfileOpen) {
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setSelectedPhotoFile(null);
      setPhotoPreviewUrl("");
      setEditProfileError("");
      setEditProfileSuccess("");
    }
  }, [isEditProfileOpen]);

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith("image/")) {
        setEditProfileError("Please select a valid image file (PNG/JPG).");
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        setEditProfileError("File size must be less than 2MB.");
        return;
      }
      setSelectedPhotoFile(file);
      setPhotoPreviewUrl(URL.createObjectURL(file));
      setEditProfileError("");
    }
  };

  const handleSaveProfileChanges = async (e) => {
    e.preventDefault();
    setEditProfileError("");
    setEditProfileSuccess("");

    const hasPhotoChange = selectedPhotoFile !== null;
    const hasPasswordChange = currentPassword.trim() || newPassword.trim() || confirmPassword.trim();

    if (!hasPhotoChange && !hasPasswordChange) {
      setEditProfileError("No changes detected. Update your profile picture or change password.");
      return;
    }

    if (hasPasswordChange) {
      if (!currentPassword.trim()) {
        setEditProfileError("Please enter your current password.");
        return;
      }
      if (!newPassword.trim()) {
        setEditProfileError("Please enter your new password.");
        return;
      }
      if (newPassword.length < 6) {
        setEditProfileError("New password must be at least 6 characters long.");
        return;
      }
      if (newPassword !== confirmPassword) {
        setEditProfileError("Passwords do not match.");
        return;
      }
    }

    setIsSubmittingProfile(true);

    try {
      if (hasPhotoChange) {
        if (!selectedPlayerId) {
          throw new Error("No active player profile found.");
        }
        await uploadPlayerPhoto(selectedPlayerId, selectedPhotoFile);
      }

      if (hasPasswordChange) {
        await changePassword(currentPassword.trim(), newPassword.trim());
      }

      setEditProfileSuccess("Profile updated successfully!");

      // Refresh player details after photo upload
      if (selectedPlayerId) {
        const response = await api.get(`/Player/${selectedPlayerId}`);
        setPlayerDetails(response.data);
      }

      setTimeout(() => {
        setIsEditProfileOpen(false);
        setEditProfileSuccess("");
      }, 2000);
    } catch (err) {
      console.error("Error updating profile:", err);
      let errMsg = "Failed to update profile. Please try again.";
      if (err.response?.data) {
        if (typeof err.response.data === "string") {
          errMsg = err.response.data;
        } else if (err.response.data.message) {
          errMsg = err.response.data.message;
        } else if (err.response.data.error) {
          errMsg = err.response.data.error;
        }
      } else if (err.message) {
        errMsg = err.message;
      }
      setEditProfileError(errMsg);
    } finally {
      setIsSubmittingProfile(false);
    }
  };

  return (
    <div className="mem-page print-area">
      {/* ── 1. DASHBOARD HERO BANNER ── */}
      <div className="reg-hero success-banner no-print">
        <div className="reg-hero-grid" />
        <div className="reg-hero-ghost">PORTAL</div>

        <div className="reg-hero-left">
          <div className="reg-hero-pill">
            <span className="reg-hero-dot" />
            Official ADBA Player Dashboard
          </div>
          <h1 style={{ fontSize: "clamp(2rem, 4.5vw, 3.8rem)" }}>
            <span className="l1">WELCOME,</span>
            <span className="l2">{(player.FirstName || "GUEST").toUpperCase()}.</span>
          </h1>
        </div>

        <div className="reg-hero-right">
          <p className="reg-hero-sub" style={{ margin: "0 auto", fontSize: "14.5px" }}>
            Your player affiliation profile is active. Review your secure registration details on the left, or view upcoming association matches on the right.
          </p>
        </div>
      </div>

      {/* ── 2. DASHBOARD BODY SPLIT LAYOUT ── */}
      <div className="reg-body">
        <div className="reg-container split-layout" style={{ maxWidth: "1200px" }}>

          {/* LEFT COLUMN: PREMIUM PLAYER DETAILS CARD */}
          <div className="mem-column card-column">
            <div className="id-card-instructions no-print" style={{ marginBottom: "5px" }}>
              <h3 style={{ textTransform: "uppercase", fontSize: "15px", letterSpacing: "0.5px" }}>Profile Details</h3>
              {/*<p>Your official registered credentials in the Anand District database.</p>*/}
            </div>

            {/* Player Selection Trigger / Active Status */}
            {loadingPlayers ? (
              <div style={{ display: "flex", alignItems: "center", gap: "10px", margin: "15px 0" }} className="no-print">
                <div className="login-loader" style={{ width: "16px", height: "16px", border: "2px solid rgba(204,0,0,0.1)", borderTopColor: "var(--r3)" }} />
                <span style={{ fontSize: "12px", color: "var(--sub)", fontWeight: "500" }}>Loading registered profiles...</span>
              </div>
            ) : players.length > 0 ? (
              <div className="no-print" style={{ marginBottom: "24px" }}>
                <button
                  type="button"
                  onClick={() => setIsModalOpen(true)}
                  style={{
                    width: "100%",
                    padding: "12px 20px",
                    borderRadius: "12px",
                    border: "1.5px solid var(--border)",
                    background: "linear-gradient(135deg, rgba(204, 0, 0, 0.03), rgba(204, 0, 0, 0.08))",
                    color: "var(--text)",
                    fontFamily: "var(--fu)",
                    fontWeight: "700",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.02)"
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: "var(--r3)", animation: "hpuls 2s ease-in-out infinite" }} />
                    <span>Active: {player.FirstName} {player.LastName}</span>
                  </div>
                  <span style={{ fontSize: "12px", color: "var(--r3)", textTransform: "uppercase", letterSpacing: "0.5px" }}>Switch Profile ⇄</span>
                </button>
              </div>
            ) : (
              <div
                className="no-print"
                onClick={() => navigate("/playerregister")}
                style={{
                  padding: "24px",
                  borderRadius: "16px",
                  border: "2px dashed var(--r3)",
                  background: "rgba(204,0,0,0.02)",
                  textAlign: "center",
                  cursor: "pointer",
                  marginBottom: "24px",
                  transition: "all 0.3s ease"
                }}
              >
                <div style={{ fontSize: "36px", marginBottom: "10px" }}>➕</div>
                <h4 style={{ fontFamily: "var(--fu)", color: "var(--text)", fontWeight: "700", margin: "0 0 6px" }}>Add New Player Profile</h4>
                <p style={{ fontSize: "13px", color: "var(--sub)", margin: 0 }}>
                  No player profiles found on your account. Click here to register your first player.
                </p>
              </div>
            )}

            {/* ✅ Only show ID card & download buttons if at least one player exists */}
            {players.length > 0 && (
              <>
                {/* Official Digital ID Card */}
                <div className="reg-id-card-frame" style={{ width: "100%", maxWidth: "420px", margin: "0 auto" }}>
                  <div className="reg-id-card light-id-card vertical-badge-layout" style={{ position: "relative", overflow: "hidden" }}>
                    {loadingDetails && (
                      <div className="no-print" style={{
                        position: "absolute",
                        inset: 0,
                        background: "rgba(255, 255, 255, 0.75)",
                        backdropFilter: "blur(4px)",
                        zIndex: 20,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        gap: "10px"
                      }}>
                        <div className="login-loader" style={{ width: "24px", height: "24px", border: "3px solid rgba(204,0,0,0.1)", borderTopColor: "var(--r3)" }} />
                        <span style={{ fontFamily: "var(--fu)", fontSize: "12px", color: "var(--sub)", fontWeight: "700", letterSpacing: "1px" }}>LOADING DATA...</span>
                      </div>
                    )}

                    <div
                      className="id-card-watermark"
                      style={{
                        position: "absolute",
                        inset: 0,
                        backgroundImage: `url(${badmintonBg})`,
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        opacity: 0.05,
                        pointerEvents: "none",
                        zIndex: 1,
                      }}
                    />
                    <div className="badge-header">
                      <div className="badge-logo-container">
                        <img src="/logo.png" alt="ADBA Logo" crossOrigin="anonymous" />
                      </div>
                      <div className="badge-header-text">
                        <h2 className="badge-title">ANAND DISTRICT BADMINTON ASSOCIATION</h2>
                        <span className="badge-subtitle">ADBA AFFILIATED PLAYER CARD</span>
                      </div>
                    </div>
                    <div className="badge-photo-wrapper">
                      <div className="badge-photo-ring">
                        <div className="badge-photo-inner">
                          <img
                            src={player.PhotoUrl || "https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?q=80&w=400&auto=format&fit=crop"}
                            alt="Affiliated Player"
                            crossOrigin="anonymous"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="badge-player-info">
                      <h3 className="badge-player-name">{player.FirstName} {player.LastName}</h3>
                      <div className="badge-player-code">{player.PlayerCode}</div>
                      {/* {membershipStatus.isLoading ? (
                        <div className="badge-player-code" style={{ opacity: 0.5 }}>Verifying membership...</div>
                      ) : membershipStatus.hasRecord === false ? (
                        <div className="badge-player-code" style={{ color: "#d9534f", fontSize: "12px", fontWeight: "600", background: "rgba(217,83,79,0.1)", padding: "6px 10px", borderRadius: "8px" }}>
                          ⚠️ No membership found. Please become a member first.
                        </div>
                      ) : membershipStatus.isActive ? (
                        <div className="badge-player-code">{player.PlayerCode}</div>
                      ) : (
                        <div className="badge-player-code" style={{ color: "#f0ad4e", fontSize: "12px", fontWeight: "600", background: "rgba(240,173,78,0.1)", padding: "6px 10px", borderRadius: "8px" }}>
                          ⚠️ Membership Inactive / Expired
                        </div>
                      )} */}
                    </div>
                    <div className="badge-details-list">
                      <div className="badge-detail-item">
                        <span className="badge-detail-label">Taluka:</span>
                        <span className="badge-detail-value">{player.SubDistrict || "Anand"}</span>
                      </div>
                      <div className="badge-detail-item">
                        <span className="badge-detail-label">District:</span>
                        <span className="badge-detail-value">{player.District}</span>
                      </div>
                    </div>
                    <div className="badge-qr-section">
                      <div className="badge-qr-box">
                        <img
                          src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&color=1a0000&data=${encodeURIComponent(
                            `ADBA OFFICIAL PLAYER VERIFIED\nID: ${player.PlayerCode}\nName: ${player.FirstName} ${player.LastName}\nTaluka: ${player.SubDistrict || "Anand"}\nDistrict: ${player.District}\nStatus: ACTIVE PLAYER`
                          )}`}
                          alt="Verification QR Code"
                          crossOrigin="anonymous"
                        />
                      </div>
                      <span className="badge-qr-caption">Scan for verification details</span>
                    </div>
                  </div>
                </div>

                {/* Download Buttons */}
                <div className="mem-actions no-print" style={{ marginTop: "24px" }}>
                  <button type="button" onClick={handleDownloadPDF} className="reg-btn-back font-adjust">
                    <DownloadIcon /> Download Player Card
                  </button>
                  <button type="button" onClick={() => setIsEditProfileOpen(true)} className="reg-btn-next font-adjust" style={{ width: "auto" }}>
                    <EditIcon /> Edit Profile
                  </button>
                </div>
              </>
            )}

            {/* Informational message when no player exists */}
            {!loadingPlayers && players.length === 0 && (
              <div className="no-print" style={{ marginTop: "24px", padding: "20px", textAlign: "center", background: "rgba(0,0,0,0.02)", borderRadius: "16px", border: "1px solid var(--border)" }}>
                <ShuttleBadgeIcon style={{ width: "32px", height: "32px", opacity: 0.4, marginBottom: "8px" }} />
                <p style={{ color: "var(--sub)", fontSize: "14px", margin: 0 }}>
                  📌 Once you add a player profile, the digital ID card and download options will appear here.
                </p>
              </div>
            )}
          </div>

          {/* <div className="mem-column card-column">
            <div className="id-card-instructions no-print">
              <h3 style={{ textTransform: "uppercase", fontSize: "15px", letterSpacing: "0.5px" }}>Affiliation Details</h3>
              <p>Your official registered credentials in the Anand District database.</p>
            </div>

           
            {loadingPlayers ? (
              <div style={{ display: "flex", alignItems: "center", gap: "10px", margin: "15px 0" }} className="no-print">
                <div className="login-loader" style={{ width: "16px", height: "16px", border: "2px solid rgba(204,0,0,0.1)", borderTopColor: "var(--r3)" }} />
                <span style={{ fontSize: "12px", color: "var(--sub)", fontWeight: "500" }}>Loading registered profiles...</span>
              </div>
            ) : players.length > 0 ? (
              <div className="no-print" style={{ marginBottom: "24px" }}>
                <button
                  type="button"
                  onClick={() => setIsModalOpen(true)}
                  style={{
                    width: "100%",
                    padding: "12px 20px",
                    borderRadius: "12px",
                    border: "1.5px solid var(--border)",
                    background: "linear-gradient(135deg, rgba(204, 0, 0, 0.03), rgba(204, 0, 0, 0.08))",
                    color: "var(--text)",
                    fontFamily: "var(--fu)",
                    fontWeight: "700",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.02)"
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: "var(--r3)", animation: "hpuls 2s ease-in-out infinite" }} />
                    <span>Active: {player.FirstName} {player.LastName}</span>
                  </div>
                  <span style={{ fontSize: "12px", color: "var(--r3)", textTransform: "uppercase", letterSpacing: "0.5px" }}>Switch Profile ⇄</span>
                </button>
              </div>
            ) : (
              <div
                className="no-print"
                onClick={() => navigate("/playerregister")}
                style={{
                  padding: "24px",
                  borderRadius: "16px",
                  border: "2px dashed var(--r3)",
                  background: "rgba(204,0,0,0.02)",
                  textAlign: "center",
                  cursor: "pointer",
                  marginBottom: "24px",
                  transition: "all 0.3s ease"
                }}
              >
                <div style={{ fontSize: "36px", marginBottom: "10px" }}>➕</div>
                <h4 style={{ fontFamily: "var(--fu)", color: "var(--text)", fontWeight: "700", margin: "0 0 6px" }}>Add New Player Profile</h4>
                <p style={{ fontSize: "13px", color: "var(--sub)", margin: 0 }}>
                  No player profiles found on your account. Click here to register your first player.
                </p>
              </div>
            )}

            <div className="reg-id-card-frame" style={{ width: "100%", maxWidth: "420px", margin: "0 auto" }}>
              <div className="reg-id-card light-id-card vertical-badge-layout" style={{ position: "relative", overflow: "hidden" }}>
                {loadingDetails && (
                  <div className="no-print" style={{
                    position: "absolute",
                    inset: 0,
                    background: "rgba(255, 255, 255, 0.75)",
                    backdropFilter: "blur(4px)",
                    zIndex: 20,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: "10px"
                  }}>
                    <div className="login-loader" style={{ width: "24px", height: "24px", border: "3px solid rgba(204,0,0,0.1)", borderTopColor: "var(--r3)" }} />
                    <span style={{ fontFamily: "var(--fu)", fontSize: "12px", color: "var(--sub)", fontWeight: "700", letterSpacing: "1px" }}>LOADING DATA...</span>
                  </div>
                )}

                <div
                  className="id-card-watermark"
                  style={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `url(${badmintonBg})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    opacity: 0.05,
                    pointerEvents: "none",
                    zIndex: 1,
                  }}
                />
                <div className="badge-header">
                  <div className="badge-logo-container">
                    <img src="/logo.png" alt="ADBA Logo" crossOrigin="anonymous" />
                  </div>
                  <div className="badge-header-text">
                    <h2 className="badge-title">ANAND DISTRICT BADMINTON ASSOCIATION</h2>
                    <span className="badge-subtitle">ADBA AFFILIATED PLAYER CARD</span>
                  </div>
                </div>
                <div className="badge-photo-wrapper">
                  <div className="badge-photo-ring">
                    <div className="badge-photo-inner">
                      <img
                        src={player.PhotoUrl || "https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?q=80&w=400&auto=format&fit=crop"}
                        alt="Affiliated Player"
                        crossOrigin="anonymous"
                      />
                    </div>
                  </div>
                </div>
                <div className="badge-player-info">
                  <h3 className="badge-player-name">{player.FirstName} {player.LastName}</h3>
                  <div className="badge-player-code">{player.PlayerCode}</div>
                  {membershipStatus.isLoading ? (
                    <div className="badge-player-code" style={{ opacity: 0.5 }}>Verifying membership...</div>
                  ) : membershipStatus.hasRecord === false ? (
                    <div className="badge-player-code" style={{ color: "#d9534f", fontSize: "12px", fontWeight: "600", background: "rgba(217,83,79,0.1)", padding: "6px 10px", borderRadius: "8px" }}>
                      ⚠️ No membership found. Please become a member first.
                    </div>
                  ) : membershipStatus.isActive ? (
                    <div className="badge-player-code">{player.PlayerCode}</div>
                  ) : (
                    <div className="badge-player-code" style={{ color: "#f0ad4e", fontSize: "12px", fontWeight: "600", background: "rgba(240,173,78,0.1)", padding: "6px 10px", borderRadius: "8px" }}>
                      ⚠️ Membership Inactive / Expired
                    </div>
                  )}
                </div>
                <div className="badge-details-list">
                  <div className="badge-detail-item">
                    <span className="badge-detail-label">Taluka:</span>
                    <span className="badge-detail-value">{player.SubDistrict || "Anand"}</span>
                  </div>
                  <div className="badge-detail-item">
                    <span className="badge-detail-label">District:</span>
                    <span className="badge-detail-value">{player.District}</span>
                  </div>

                </div>
                <div className="badge-qr-section">
                  <div className="badge-qr-box">
                    <img
                      src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&color=1a0000&data=${encodeURIComponent(
                        `ADBA OFFICIAL PLAYER VERIFIED\nID: ${player.PlayerCode}\nName: ${player.FirstName} ${player.LastName}\nGender: ${player.Gender}\nDOB: ${player.Dob}\nTaluka: ${player.SubDistrict || "Anand"}\nDistrict: ${player.District}\nInstitution: ${player.InstitutionName || "N/A"}\nRef ID: ${player.PaymentId}\nStatus: ACTIVE PLAYER`
                      )}`}
                      alt="Verification QR Code"
                      crossOrigin="anonymous"
                    />
                  </div>
                  <span className="badge-qr-caption">Scan for verification details</span>
                </div>



              </div>
            </div>


            <div className="mem-actions no-print" style={{ marginTop: "24px" }}>
              <button type="button" onClick={handleDownloadPDF} className="reg-btn-back font-adjust">
                <DownloadIcon /> Download Player Card
              </button>
              <button type="button" onClick={() => navigate("/")} className="reg-btn-next font-adjust" style={{ width: "auto" }}>
                <HomeIcon /> Return Home
              </button>
            </div>
          </div> */}

          {/* RIGHT COLUMN: EVENTS TABLE IDENTICAL TO HOME.JSX */}
          <div className="mem-column events-column no-print">
            <div className="id-card-instructions" style={{ marginBottom: "20px" }}>
              <div className="hp-stag"><span className="hp-stag-bar" />Upcoming Tournaments</div>
              <h2 className="hp-rtitle" style={{ fontSize: "clamp(26px, 3.5vw, 40px)", margin: "8px 0" }}>
                📍 DISTRICT LEVEL <span className="accent">CALENDAR.</span>
              </h2>
              {/* <p style={{ margin: "10px 0 0", fontSize: "14.5px", color: "var(--sub)" }}>
                Official upcoming district tournament matches affiliated to Gujarat Badminton Association.
              </p> */}
            </div>

            {/* Event Table identical to Home.jsx (no custom inline style overrides) */}
            <div className="ev-table-wrap fired"
              style={{
                maxHeight: "290px", // Changed from 380px to restrict view to ~5 rows
                overflowY: "auto",
                border: "1.5px solid var(--border)",
                borderRadius: "16px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.02)"
              }}>
              <table style={{ minWidth: "600px" }}>
                <thead style={{ position: "sticky", top: 0, zIndex: 10 }}>
                  <tr style={{ background: "var(--rg)" }}>
                    <th>Sr.</th>
                    <th>Date</th>
                    <th>Tournament</th>
                    <th>Category</th>
                    <th>Venue</th>
                    {/* {players && players.length > 0 && <th>Action</th>} */}
                  </tr>
                </thead>
                <tbody>
                  {loadingTournaments ? (
                    <tr>
                      <td colSpan={players && players.length > 0 ? 6 : 5} style={{ textAlign: "center", padding: "30px" }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                          <div className="login-loader" style={{ width: "20px", height: "20px", border: "2.5px solid rgba(204,0,0,0.1)", borderTopColor: "var(--r3)" }} />
                          <span style={{ fontSize: "14px", color: "var(--sub)", fontWeight: "500" }}>Fetching calendar...</span>
                        </div>
                      </td>
                    </tr>
                  ) : tournaments.length === 0 ? (
                    <tr>
                      <td colSpan={players && players.length > 0 ? 6 : 5} style={{ textAlign: "center", padding: "30px", color: "var(--sub)", fontSize: "14px" }}>
                        No upcoming tournaments scheduled.
                      </td>
                    </tr>
                  ) : (
                    tournaments.filter(t => {
                      if (!t.startDate) return false;
                      const today = new Date();
                      today.setHours(0, 0, 0, 0);
                      // Tomorrow = today + 1 day
                      const tomorrow = new Date(today);
                      tomorrow.setDate(today.getDate() + 1);
                      const startDate = new Date(t.startDate);
                      startDate.setHours(0, 0, 0, 0);
                      return startDate >= tomorrow;
                    }).map((t, idx) => {
                      const cats = getTournamentCategoryNames(t.categories);
                      const isRegisteredAll = cats.length > 0 && cats.every(c => registrationStatuses[c.tournamentCategoryId] === true);
                      return (
                        <tr key={t.tournamentId} className={t.status === "Upcoming" ? "t-hl" : ""}>
                          <td className="t-sr">{String(idx + 1).padStart(2, "0")}</td>
                          <td className="t-date" style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
                            {formatDateRange(t.startDate, t.endDate)}
                          </td>
                          <td>
                            <div style={{ fontWeight: "700", color: "var(--text)" }}>{t.tournamentName}</div>
                            {/* <div style={{ fontSize: "11px", color: "var(--sub)" }}>Fee: ₹{t.entryFee}</div> */}
                          </td>
                          <td>
                            <div className="category-badges-wrapper" style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                              {cats.map((c, i) => (
                                <span key={i} className="cat-b cb-ranking" style={{ fontSize: "9px", padding: "3px 8px", background: "rgba(204, 0, 0, 0.05)", color: "var(--r3)", borderRadius: "100px", fontWeight: "700" }}>
                                  {c.name}
                                </span>
                              ))}
                            </div>
                          </td>
                          <td>{t.venue}</td>
                          {/* {players && players.length > 0 && (
                            <td>
                              {getTournamentStatus(t.startDate, t.endDate) === "Upcoming" ? (
                                isRegisteredAll ? (
                                  <button
                                    type="button"
                                    disabled
                                    style={{
                                      padding: "6px 12px",
                                      borderRadius: "6px",
                                      background: "var(--border)",
                                      color: "var(--sub)",
                                      fontFamily: "var(--fu)",
                                      fontWeight: "700",
                                      fontSize: "11px",
                                      letterSpacing: "0.5px",
                                      textTransform: "uppercase",
                                      cursor: "not-allowed",
                                      border: "1.5px solid var(--border)",
                                      display: "inline-block"
                                    }}
                                  >
                                    Registered
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    onClick={() => setRegistrationModalTournament(t)}
                                    style={{
                                      padding: "6px 12px",
                                      borderRadius: "6px",
                                      background: "var(--rg)",
                                      color: "#fff",
                                      fontFamily: "var(--fu)",
                                      fontWeight: "700",
                                      fontSize: "11px",
                                      letterSpacing: "0.5px",
                                      textTransform: "uppercase",
                                      cursor: "pointer",
                                      boxShadow: "0 2px 6px rgba(204,0,0,0.15)",
                                      transition: "all 0.2s"
                                    }}
                                  >
                                    Register
                                  </button>
                                )
                              ) : getTournamentStatus(t.startDate, t.endDate) === "Ongoing" ? (
                                <span style={{
                                  fontSize: "10px",
                                  padding: "4px 8px",
                                  background: "rgba(240, 173, 78, 0.1)",
                                  color: "#f0ad4e",
                                  borderRadius: "6px",
                                  fontWeight: "700",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                  display: "inline-block"
                                }}>
                                  Ongoing
                                </span>
                              ) : (
                                <span style={{
                                  fontSize: "10px",
                                  padding: "4px 8px",
                                  background: "rgba(100, 100, 100, 0.08)",
                                  color: "#888",
                                  borderRadius: "6px",
                                  fontWeight: "700",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                  display: "inline-block"
                                }}>
                                  Closed
                                </span>
                              )}
                            </td>
                          )} */}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Direct Register notice card */}
            {/* <div style={{ marginTop: "24px", background: "linear-gradient(135deg, rgba(204, 0, 0, 0.02), rgba(204, 0, 0, 0.05))", border: "1px solid var(--border)", borderRadius: "16px", padding: "20px 24px" }}>
              <h4 style={{ margin: "0 0 6px", fontSize: "14px", color: "var(--r3)", fontWeight: "700" }}>Affiliate Benefits Active</h4>
              <p style={{ margin: 0, fontSize: "12px", color: "var(--sub)", lineHeight: "1.6" }}>
                As an official ADBA registered player, you receive priority entrance slot confirmations, 15% discount on all entry booking passes, and a free personalized official association jersey!
              </p>
            </div> */}


            <div style={{ marginTop: "20px" }}>
              <div className="id-card-instructions" style={{ marginBottom: "16px" }}>
                <div className="hp-stag"><span className="hp-stag-bar" style={{ background: "var(--r3)" }} />My Registrations</div>
                <h2 className="hp-rtitle" style={{ fontSize: "clamp(22px, 3vw, 32px)", margin: "4px 0 0" }}>
                  🏸 MY <span className="accent">TOURNAMENTS.</span>
                </h2>
                <p style={{ fontSize: "12px", color: "var(--sub)", marginTop: "6px" }}>
                  Tournaments you have registered for (upcoming & ongoing).
                </p>
              </div>

              <div className="ev-table-wrap fired"
                style={{
                  maxHeight: "290px",
                  overflowY: "auto",
                  border: "1.5px solid var(--border)",
                  borderRadius: "16px",
                  boxShadow: "0 8px 30px rgba(0,0,0,0.02)"
                }}>
                <table style={{ minWidth: "600px" }}>
                  <thead style={{ position: "sticky", top: 0, zIndex: 10 }}>
                    <tr style={{ background: "var(--rg)" }}>
                      <th>Sr.</th>
                      <th>Date</th>
                      <th>Tournament</th>
                      <th>Category (Registered)</th>
                      <th>Venue</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loadingRegistrations || loadingTournaments ? (
                      <tr>
                        <td colSpan="6" style={{ textAlign: "center", padding: "30px" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                            <div className="login-loader" style={{ width: "20px", height: "20px", border: "2.5px solid rgba(204,0,0,0.1)", borderTopColor: "var(--r3)" }} />
                            <span style={{ fontSize: "14px", color: "var(--sub)", fontWeight: "500" }}>Loading your registrations...</span>
                          </div>
                        </td>
                      </tr>
                    ) : (() => {
                      // Filter tournaments where the player has at least one registration
                      const registeredTournaments = tournaments.filter(t => {
                        if (!t.categories) return false;
                        return t.categories.some(cat => registrationStatuses[cat.tournamentCategoryId] === true);
                      });

                      // Further filter to only upcoming/ongoing (exclude closed)
                      const activeRegisteredTournaments = registeredTournaments.filter(t => {
                        const status = getTournamentStatus(t.startDate, t.endDate);
                        return status !== "Closed";
                      });

                      if (activeRegisteredTournaments.length === 0) {
                        return (
                          <tr>
                            <td colSpan="6" style={{ textAlign: "center", padding: "30px", color: "var(--sub)", fontSize: "14px" }}>
                              You haven't registered for any upcoming or ongoing tournaments.
                            </td>
                          </tr>
                        );
                      }

                      return activeRegisteredTournaments.map((t, idx) => {
                        const allCats = getTournamentCategoryNames(t.categories);
                        const registeredCats = allCats.filter(c => registrationStatuses[c.tournamentCategoryId] === true);
                        const tournamentStatus = getTournamentStatus(t.startDate, t.endDate);
                        const statusLabel = tournamentStatus === "Upcoming" ? "UPCOMING" : "ONGOING";
                        const statusColor = tournamentStatus === "Upcoming" ? "#28a745" : "#f0ad4e";

                        return (
                          <tr key={t.tournamentId}>
                            <td className="t-sr">{String(idx + 1).padStart(2, "0")}</td>
                            <td className="t-date" style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
                              {formatDateRange(t.startDate, t.endDate)}
                            </td>
                            <td>
                              <div style={{ fontWeight: "700", color: "var(--text)" }}>{t.tournamentName}</div>
                              <div style={{ fontSize: "11px", color: "var(--sub)" }}>Fee: ₹{t.entryFee}</div>
                            </td>
                            <td>
                              <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                                {registeredCats.map((c, i) => (
                                  <span key={i} style={{ fontSize: "9px", padding: "3px 8px", background: "rgba(40,167,69,0.15)", color: "#28a745", borderRadius: "100px", fontWeight: "700" }}>
                                    {c.name} ✓
                                  </span>
                                ))}
                              </div>
                            </td>
                            <td>{t.venue}</td>
                            <td>
                              <span style={{ fontSize: "10px", padding: "4px 8px", background: `${statusColor}15`, color: statusColor, borderRadius: "6px", fontWeight: "700" }}>
                                {statusLabel}
                              </span>
                            </td>
                          </tr>
                        );
                      });
                    })()}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>

      </div>

      {/* Edit Profile Modal */}
      {isEditProfileOpen && (
        <div style={{
          position: "fixed",
          inset: 0,
          background: "rgba(20, 0, 0, 0.65)",
          backdropFilter: "blur(8px)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
          cursor: "pointer"
        }}
          onClick={() => setIsEditProfileOpen(false)}
        >
          <div
            style={{
              background: "#fff",
              width: "100%",
              maxWidth: "800px",
              borderRadius: "24px",
              padding: "32px",
              boxShadow: "0 20px 50px rgba(0,0,0,0.25)",
              border: "1px solid var(--border)",
              position: "relative",
              overflow: "hidden",
              cursor: "default"
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* Header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px", borderBottom: "1.5px solid var(--border)", paddingBottom: "16px" }}>
              <div>
                <h3 style={{ fontFamily: "var(--fu)", fontSize: "20px", fontWeight: "800", color: "var(--text)", margin: 0 }}>
                  EDIT PROFILE
                </h3>
                <p style={{ fontSize: "13px", color: "var(--sub)", margin: "4px 0 0" }}>
                  Upload a new profile picture or update your account password.
                </p>
              </div>
              <button
                onClick={() => setIsEditProfileOpen(false)}
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  background: "var(--off)",
                  border: "none",
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "var(--sub)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "background 0.2s"
                }}
              >
                ✕
              </button>
            </div>

            {/* Error or Success notification */}
            {editProfileSuccess && (
              <div style={{ padding: "12px 16px", borderRadius: "10px", background: "rgba(40,167,69,0.1)", color: "#28a745", fontSize: "13px", fontWeight: "600", marginBottom: "20px" }}>
                ✅ {editProfileSuccess}
              </div>
            )}
            {editProfileError && (
              <div style={{ padding: "12px 16px", borderRadius: "10px", background: "rgba(220,53,69,0.1)", color: "#dc3545", fontSize: "13px", fontWeight: "600", marginBottom: "20px" }}>
                ⚠️ {editProfileError}
              </div>
            )}

            <form onSubmit={handleSaveProfileChanges} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: "24px" }}>
              {/* Left Column: Profile Picture & Details */}
              <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "20px", background: "var(--off)", padding: "16px", borderRadius: "16px", border: "1px solid var(--border)" }}>
                  {/* Photo Preview & File Input */}
                  <div style={{ position: "relative", width: "80px", height: "80px", borderRadius: "50%", overflow: "hidden", border: "3px solid var(--border)", flexShrink: 0 }}>
                    <img
                      src={photoPreviewUrl || player.PhotoUrl || "https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?q=80&w=400&auto=format&fit=crop"}
                      alt="Profile Preview"
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  </div>
                  <div>
                    <label style={{ display: "inline-block", padding: "8px 14px", background: "var(--r3)", color: "#fff", borderRadius: "8px", fontSize: "12px", fontWeight: "700", cursor: "pointer", transition: "opacity 0.2s" }} className="font-adjust">
                      Upload New Photo
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handlePhotoChange}
                        style={{ display: "none" }}
                      />
                    </label>
                    <p style={{ fontSize: "11px", color: "var(--sub)", marginTop: "6px", margin: 0 }}>
                      PNG, JPG up to 2MB
                    </p>
                    {selectedPhotoFile && (
                      <span style={{ display: "block", fontSize: "11px", color: "#28a745", fontWeight: "600", marginTop: "4px" }}>
                        ✓ Selected: {selectedPhotoFile.name.substring(0, 15)}...
                      </span>
                    )}
                  </div>
                </div>

                {/* Read-only Details Grid */}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", background: "var(--off)", padding: "20px", borderRadius: "16px", border: "1px solid var(--border)" }}>
                  <div style={{ gridColumn: "span 2", borderBottom: "1px solid var(--border)", paddingBottom: "8px", marginBottom: "4px" }}>
                    <span style={{ fontSize: "10px", color: "var(--r3)", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>Player Affiliation Details</span>
                  </div>
                  <div>
                    <span style={{ fontSize: "11px", color: "var(--sub)", display: "block" }}>Full Name</span>
                    <span style={{ fontSize: "13.5px", fontWeight: "700", color: "var(--text)" }}>{player.FirstName} {player.LastName}</span>
                  </div>
                  <div>
                    <span style={{ fontSize: "11px", color: "var(--sub)", display: "block" }}>Player Code</span>
                    <span style={{ fontSize: "13.5px", fontWeight: "700", color: "var(--text)" }}>{player.PlayerCode}</span>
                  </div>
                  <div>
                    <span style={{ fontSize: "11px", color: "var(--sub)", display: "block" }}>Mobile Number</span>
                    <span style={{ fontSize: "13.5px", fontWeight: "700", color: "var(--text)" }}>{sessionStorage.getItem("mobileNumber") || "N/A"}</span>
                  </div>
                  <div>
                    <span style={{ fontSize: "11px", color: "var(--sub)", display: "block" }}>Gender</span>
                    <span style={{ fontSize: "13.5px", fontWeight: "700", color: "var(--text)" }}>{player.Gender}</span>
                  </div>
                  <div>
                    <span style={{ fontSize: "11px", color: "var(--sub)", display: "block" }}>Date of Birth</span>
                    <span style={{ fontSize: "13.5px", fontWeight: "700", color: "var(--text)" }}>
                      {player.Dob ? new Date(player.Dob).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "N/A"}
                    </span>
                  </div>
                  <div>
                    <span style={{ fontSize: "11px", color: "var(--sub)", display: "block" }}>Taluka & District</span>
                    <span style={{ fontSize: "13.5px", fontWeight: "700", color: "var(--text)" }}>{player.SubDistrict || "Anand"}, {player.District}</span>
                  </div>
                </div>
              </div>

              {/* Right Column: Change Password */}
              <div style={{ display: "flex", flexDirection: "column", gap: "20px", padding: "16px", border: "1.5px solid var(--border)", borderRadius: "16px" }}>
                <div>
                  <span style={{ fontSize: "10px", color: "var(--r3)", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px", display: "block", marginBottom: "4px" }}>Security & Credentials</span>
                  <h4 style={{ fontFamily: "var(--fu)", fontSize: "16px", fontWeight: "800", color: "var(--text)", margin: 0 }}>
                    CHANGE PASSWORD
                  </h4>
                  <p style={{ fontSize: "11px", color: "var(--sub)", margin: "4px 0 0" }}>
                    Leave these fields blank if you do not wish to update your password.
                  </p>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  <div>
                    <label style={{ display: "block", fontSize: "12px", fontWeight: "700", color: "var(--text)", marginBottom: "4px" }}>Current Password</label>
                    <input
                      type="password"
                      value={currentPassword}
                      onChange={e => setCurrentPassword(e.target.value)}
                      placeholder="Enter current password"
                      style={{ width: "100%", padding: "10px 14px", borderRadius: "10px", border: "1.5px solid var(--border)", fontFamily: "var(--fu)", fontSize: "13px" }}
                    />
                  </div>
                  <div>
                    <label style={{ display: "block", fontSize: "12px", fontWeight: "700", color: "var(--text)", marginBottom: "4px" }}>New Password</label>
                    <input
                      type="password"
                      value={newPassword}
                      onChange={e => setNewPassword(e.target.value)}
                      placeholder="Minimum 6 characters"
                      style={{ width: "100%", padding: "10px 14px", borderRadius: "10px", border: "1.5px solid var(--border)", fontFamily: "var(--fu)", fontSize: "13px" }}
                    />
                  </div>
                  <div>
                    <label style={{ display: "block", fontSize: "12px", fontWeight: "700", color: "var(--text)", marginBottom: "4px" }}>Confirm New Password</label>
                    <input
                      type="password"
                      value={confirmPassword}
                      onChange={e => setConfirmPassword(e.target.value)}
                      placeholder="Re-enter new password"
                      style={{ width: "100%", padding: "10px 14px", borderRadius: "10px", border: "1.5px solid var(--border)", fontFamily: "var(--fu)", fontSize: "13px" }}
                    />
                  </div>
                </div>
              </div>

              {/* Form Actions Footer */}
              <div style={{ gridColumn: "span 2", display: "flex", justifyContent: "flex-end", gap: "12px", borderTop: "1.5px solid var(--border)", paddingTop: "20px", marginTop: "10px" }}>
                <button
                  type="button"
                  onClick={() => setIsEditProfileOpen(false)}
                  style={{ padding: "10px 20px", borderRadius: "10px", border: "1.5px solid var(--border)", background: "#fff", color: "var(--sub)", fontFamily: "var(--fu)", fontSize: "13px", fontWeight: "700", cursor: "pointer" }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmittingProfile}
                  style={{
                    padding: "10px 24px",
                    borderRadius: "10px",
                    background: "var(--r3)",
                    color: "#fff",
                    border: "none",
                    fontFamily: "var(--fu)",
                    fontSize: "13px",
                    fontWeight: "700",
                    cursor: isSubmittingProfile ? "not-allowed" : "pointer",
                    boxShadow: "0 4px 12px rgba(204,0,0,0.15)",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}
                >
                  {isSubmittingProfile ? (
                    <>
                      <div className="login-loader" style={{ width: "14px", height: "14px", border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "#fff" }} />
                      <span>Saving Changes...</span>
                    </>
                  ) : (
                    <span>Save Changes</span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Premium Profile Selector Modal */}
      {isModalOpen && (
        <div style={{
          position: "fixed",
          inset: 0,
          background: "rgba(20, 0, 0, 0.65)",
          backdropFilter: "blur(8px)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
          cursor: "pointer"
        }}
          onClick={() => setIsModalOpen(false)}
        >
          <div
            style={{
              background: "#fff",
              width: "100%",
              maxWidth: "680px",
              borderRadius: "24px",
              padding: "32px",
              boxShadow: "0 20px 50px rgba(0,0,0,0.25)",
              border: "1px solid var(--border)",
              position: "relative",
              overflow: "hidden",
              cursor: "default"
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* Header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px", borderBottom: "1.5px solid var(--border)", paddingBottom: "16px" }}>
              <div>
                <h3 style={{ fontFamily: "var(--fu)", fontSize: "20px", fontWeight: "800", color: "var(--text)", margin: 0 }}>
                  SELECT PLAYER PROFILE
                </h3>
                <p style={{ fontSize: "13px", color: "var(--sub)", margin: "4px 0 0" }}>
                  Switch between registered players or add a new profile.
                </p>
              </div>
              <button
                onClick={() => setIsModalOpen(false)}
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  background: "var(--off)",
                  border: "none",
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "var(--sub)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "background 0.2s"
                }}
              >
                ✕
              </button>
            </div>

            {/* Profile Grid */}
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
              gap: "16px",
              maxHeight: "380px",
              overflowY: "auto",
              padding: "4px"
            }}>
              {/* Existing Players */}
              {players.map(p => {
                const isSelected = (p.playerId || p.PlayerId) === selectedPlayerId;
                return (
                  <div
                    key={p.playerId || p.PlayerId}
                    onClick={() => {
                      setSelectedPlayerId(p.playerId || p.PlayerId);
                      setIsModalOpen(false);
                    }}
                    style={{
                      border: isSelected ? "2px solid var(--r3)" : "1.5px solid var(--border)",
                      background: isSelected ? "rgba(204, 0, 0, 0.02)" : "#fff",
                      borderRadius: "16px",
                      padding: "20px 16px",
                      cursor: "pointer",
                      transition: "all 0.25s ease",
                      textAlign: "center",
                      position: "relative",
                      boxShadow: isSelected ? "0 4px 15px rgba(204,0,0,0.08)" : "0 2px 6px rgba(0,0,0,0.02)"
                    }}
                  >
                    {isSelected && (
                      <span style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        background: "var(--r3)",
                        color: "#fff",
                        fontSize: "9px",
                        fontWeight: "700",
                        textTransform: "uppercase",
                        padding: "2px 6px",
                        borderRadius: "100px",
                        letterSpacing: "0.5px"
                      }}>
                        Active
                      </span>
                    )}

                    {/* Avatar Circle */}
                    <div style={{
                      width: "56px",
                      height: "56px",
                      borderRadius: "50%",
                      background: isSelected ? "var(--rg)" : "var(--off)",
                      color: isSelected ? "#fff" : "var(--r3)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 12px",
                      fontSize: "20px",
                      fontWeight: "700",
                      fontFamily: "var(--fu)"
                    }}>
                      {(p.firstName || p.FirstName || "?")[0].toUpperCase()}
                    </div>

                    <h4 style={{ fontFamily: "var(--fu)", fontSize: "15px", fontWeight: "700", color: "var(--text)", margin: "0 0 4px" }}>
                      {p.firstName || p.FirstName} {p.lastName || p.LastName}
                    </h4>

                    <div style={{ fontSize: "11px", color: "var(--sub)", textTransform: "uppercase", fontWeight: "600", letterSpacing: "0.3px", marginBottom: "4px" }}>
                      {p.gender || p.Gender || "N/A"}
                    </div>

                    <div style={{ fontSize: "11px", color: "var(--light)" }}>
                      DOB: {new Date(p.dob || p.Dob).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
                    </div>
                  </div>
                );
              })}

              {/* Add New User Card */}
              <div
                onClick={() => {
                  setIsModalOpen(false);
                  navigate("/playerregister");
                }}
                style={{
                  border: "2px dashed var(--border)",
                  background: "rgba(0,0,0,0.01)",
                  borderRadius: "16px",
                  padding: "20px 16px",
                  cursor: "pointer",
                  transition: "all 0.25s ease",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "165px"
                }}
              >
                <div style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "50%",
                  border: "2px dashed var(--border)",
                  color: "var(--light)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 12px",
                  fontSize: "24px",
                  fontWeight: "700"
                }}>
                  +
                </div>
                <h4 style={{ fontFamily: "var(--fu)", fontSize: "14px", fontWeight: "700", color: "var(--sub)", margin: 0 }}>
                  Add New Player
                </h4>
                <p style={{ fontSize: "11px", color: "var(--light)", margin: "4px 0 0" }}>
                  Register new profile
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Tournament Registration Modal */}
      {registrationModalTournament && (
        <div style={{
          position: "fixed",
          inset: 0,
          background: "rgba(20, 0, 0, 0.65)",
          backdropFilter: "blur(8px)",
          zIndex: 10000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
          cursor: "pointer"
        }}
          onClick={() => setRegistrationModalTournament(null)}
        >
          <div
            style={{
              background: "#fff",
              width: "100%",
              maxWidth: "520px",
              borderRadius: "24px",
              padding: "32px",
              boxShadow: "0 20px 50px rgba(0,0,0,0.25)",
              border: "1px solid var(--border)",
              position: "relative",
              cursor: "default"
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* Header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", borderBottom: "1.5px solid var(--border)", paddingBottom: "16px" }}>
              <div>
                <span style={{ fontSize: "10px", color: "var(--r3)", fontWeight: "700", textTransform: "uppercase", letterSpacing: "1px" }}>
                  Tournament Registration
                </span>
                <h3 style={{ fontFamily: "var(--fu)", fontSize: "18px", fontWeight: "800", color: "var(--text)", margin: "4px 0 0" }}>
                  {registrationModalTournament.tournamentName}
                </h3>
              </div>
              <button
                onClick={() => setRegistrationModalTournament(null)}
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  background: "var(--off)",
                  border: "none",
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "var(--sub)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer"
                }}
              >
                ✕
              </button>
            </div>

            {/* Content info */}
            <div style={{ marginBottom: "20px", background: "var(--off)", borderRadius: "12px", padding: "12px 16px" }}>
              <div style={{ fontSize: "13px", color: "var(--sub)", marginBottom: "4px" }}>
                Active Player: <strong style={{ color: "var(--text)" }}>{(player.FirstName || "GUEST")} {player.LastName || ""}</strong>
              </div>
              <div style={{ fontSize: "13px", color: "var(--sub)" }}>
                Venue: <strong style={{ color: "var(--text)" }}>{registrationModalTournament.venue}</strong>
              </div>
            </div>

            {/* Error or Success notification */}
            {registeringStatus.success && (
              <div style={{ padding: "12px 16px", borderRadius: "10px", background: "rgba(40,167,69,0.1)", color: "#28a745", fontSize: "13px", fontWeight: "600", marginBottom: "20px" }}>
                ✅ {registeringStatus.success}
              </div>
            )}
            {registeringStatus.error && (
              <div style={{ padding: "12px 16px", borderRadius: "10px", background: "rgba(220,53,69,0.1)", color: "#dc3545", fontSize: "13px", fontWeight: "600", marginBottom: "20px" }}>
                ⚠️ {registeringStatus.error}
              </div>
            )}

            {(() => {
              const allCats = getTournamentCategoryNames(registrationModalTournament.categories);
              const unregisteredCats = allCats.filter(c => registrationStatuses[c.tournamentCategoryId] !== true);
              const isAllSelected = unregisteredCats.length > 0 && unregisteredCats.every(c => selectedCategoryIds.includes(c.tournamentCategoryId));

              const handleSelectAllToggle = () => {
                if (isAllSelected) {
                  const unregisteredIds = unregisteredCats.map(c => c.tournamentCategoryId);
                  setSelectedCategoryIds(prev => prev.filter(id => !unregisteredIds.includes(id)));
                } else {
                  const unregisteredIds = unregisteredCats.map(c => c.tournamentCategoryId);
                  setSelectedCategoryIds(prev => {
                    const newIds = [...prev];
                    unregisteredIds.forEach(id => {
                      if (!newIds.includes(id)) {
                        newIds.push(id);
                      }
                    });
                    return newIds;
                  });
                }
              };

              return (
                <>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                    <h4 style={{ fontFamily: "var(--fu)", fontSize: "13px", fontWeight: "700", color: "var(--light)", textTransform: "uppercase", letterSpacing: "0.5px", margin: 0 }}>
                      Select Event Categories to Register:
                    </h4>
                    {unregisteredCats.length > 0 && (
                      <button
                        type="button"
                        onClick={handleSelectAllToggle}
                        style={{
                          background: "none",
                          border: "none",
                          color: "var(--r3)",
                          fontFamily: "var(--fu)",
                          fontWeight: "700",
                          fontSize: "11px",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          cursor: "pointer",
                          padding: 0
                        }}
                      >
                        {isAllSelected ? "Deselect All" : "Select All"}
                      </button>
                    )}
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", gap: "10px", maxHeight: "240px", overflowY: "auto", padding: "2px" }}>
                    {allCats.map((c) => {
                      const isRegistered = registrationStatuses[c.tournamentCategoryId] === true;
                      const isSelected = selectedCategoryIds.includes(c.tournamentCategoryId);
                      return (
                        <label
                          key={c.tournamentCategoryId}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "12px 16px",
                            border: isRegistered
                              ? "1.5px solid var(--border)"
                              : isSelected
                                ? "1.5px solid var(--r3)"
                                : "1.5px solid var(--border)",
                            borderRadius: "12px",
                            background: isRegistered
                              ? "rgba(0, 0, 0, 0.02)"
                              : isSelected
                                ? "rgba(204, 0, 0, 0.02)"
                                : "#fff",
                            cursor: isRegistered ? "not-allowed" : "pointer",
                            transition: "all 0.2s ease",
                            userSelect: "none"
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                            <input
                              type="checkbox"
                              disabled={isRegistered || registeringStatus.loading}
                              checked={isRegistered || isSelected}
                              onChange={() => {
                                if (isRegistered) return;
                                setSelectedCategoryIds(prev =>
                                  prev.includes(c.tournamentCategoryId)
                                    ? prev.filter(id => id !== c.tournamentCategoryId)
                                    : [...prev, c.tournamentCategoryId]
                                );
                              }}
                              style={{
                                width: "18px",
                                height: "18px",
                                accentColor: "var(--r3)",
                                cursor: isRegistered ? "not-allowed" : "pointer"
                              }}
                            />
                            <span style={{
                              fontSize: "13.5px",
                              fontWeight: "600",
                              color: isRegistered ? "var(--sub)" : "var(--text)",
                              textDecoration: isRegistered ? "line-through" : "none"
                            }}>
                              {c.name} <span style={{ color: isRegistered ? "var(--sub)" : "var(--r3)", fontWeight: "700", marginLeft: "6px" }}>- ₹{registrationModalTournament.entryFee}</span>
                            </span>
                          </div>
                          {isRegistered && (
                            <span style={{
                              fontSize: "10px",
                              fontWeight: "700",
                              color: "#28a745",
                              background: "rgba(40,167,69,0.1)",
                              padding: "4px 8px",
                              borderRadius: "6px",
                              textTransform: "uppercase",
                              letterSpacing: "0.5px"
                            }}>
                              Registered ✓
                            </span>
                          )}
                        </label>
                      );
                    })}
                  </div>

                  <button
                    type="button"
                    disabled={registeringStatus.loading || selectedCategoryIds.length === 0}
                    onClick={handleRegisterPlayerForSelectedCategories}
                    style={{
                      marginTop: "20px",
                      width: "100%",
                      padding: "14px 20px",
                      borderRadius: "12px",
                      background: selectedCategoryIds.length === 0 ? "var(--border)" : "var(--r3)",
                      color: selectedCategoryIds.length === 0 ? "var(--sub)" : "#fff",
                      fontFamily: "var(--fu)",
                      fontWeight: "700",
                      fontSize: "13px",
                      letterSpacing: "0.5px",
                      textTransform: "uppercase",
                      border: "none",
                      cursor: (registeringStatus.loading || selectedCategoryIds.length === 0) ? "not-allowed" : "pointer",
                      boxShadow: selectedCategoryIds.length === 0 ? "none" : "0 4px 12px rgba(204,0,0,0.2)",
                      transition: "all 0.2s ease",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px"
                    }}
                  >
                    {registeringStatus.loading ? (
                      <>
                        <div className="login-loader" style={{ width: "16px", height: "16px", border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "#fff" }} />
                        <span>Registering Categories...</span>
                      </>
                    ) : (
                      <span>Register Selected ({selectedCategoryIds.length})</span>
                    )}
                  </button>
                </>
              );
            })()}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDashboard;
